export { default } from './CirclePromo';
